import { connect } from '@ardoq/rxbeach';
import { Icon, IconName } from '@ardoq/icons';
import { FabContainer } from '../atoms';
import { FabColor } from '../types';
import { classes } from '@ardoq/common-helpers';
import { componentFab$ } from './componentFab$';
import { type I18nLocale, t } from '@ardoq/i18n';

export type ComponentFabProps = {
  readonly isActive: boolean;
  readonly isVisible: boolean;
  readonly onClick: VoidFunction;
  readonly i18nLocale: I18nLocale;
};

const ComponentFabBase = ({
  isActive,
  isVisible,
  onClick,
  i18nLocale,
}: ComponentFabProps) => {
  if (!isVisible) {
    return null;
  }

  const label = isActive
    ? t(i18nLocale, 'views:fab.componentFab.closeSidebar', 'Close sidebar')
    : t(i18nLocale, 'views:fab.componentFab.create', 'Create a component');

  return (
    <FabContainer
      className={classes(isActive && 'active')}
      color={FabColor.BLUE}
      onClick={onClick}
      role="button"
      aria-label={label}
      data-tooltip-text={label}
    >
      <div className="fab-main">
        <Icon iconName={IconName.CLOSE} />
      </div>
    </FabContainer>
  );
};

export const ComponentFab = connect(ComponentFabBase, componentFab$);
